import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import SelectField from '../../../_common/platform/tsx/SelectField';
import { ColorBoxField } from '../../../_common/platform/tsx/ColorBoxField'; //LL: 09.10.18

require('../sass-main/pdc-widget-gis.sass');

interface IValue {
    GIS_service: string;
    water_color: string;
    landscape_color: string;
}

export class GISMapField extends React.Component<
    {
        value?: any;
        allowNull?: boolean;
        title?: string;

        options?: {
            title?: string;
            allowNull?: boolean;
        };
        disabled?: boolean;
        readOnly?: boolean;
        glob?: IGlob;

        onChange?(value: IValue): void;
    },
    {
        value: IValue;
        scheme: string;
    }
> {
    private static DEFAULT_SCHEME = 'dark';

    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value,
            scheme: GISMapField.DEFAULT_SCHEME
        };
    }

    componentDidMount() {
        this.setScheme();
    }

    setScheme = () => {
        /* var textElement = React.findDOMNode<HTMLInputElement>(this.refs["text"]);
         var styles = getComputedStyle(textElement);
         if (styles == null) {
             return;
         }

         var isLight;
         try {
             isLight = Color(styles.color).light();
         } catch (e) {
             isLight = false;
         }

         var scheme = GISMapField.DEFAULT_SCHEME = isLight ? 'light' : 'dark';
 */
        //if (this.state.scheme !== scheme)
        {
            const state = this.state;
            //  state.scheme = scheme;
            this.setState(state);
        }
    };

    componentWillReceiveProps(newProps) {
        const newValue = newProps.value;

        if (newValue !== this.props.value) {
            this.setState({ value: newValue });
        }
    }

    handleGISserviceChange = (val: string) => {
        if (val == 'GoogleMap') {
            var value: IValue = {
                GIS_service: val,
                water_color: _.clone(this.state.value.water_color),
                landscape_color: _.clone(this.state.value.landscape_color)
            };
        } else {
            var value: IValue = {
                GIS_service: val,
                water_color: 'transparent',
                landscape_color: 'transparent'
            };
        }
        this.setState(
            _.extend(this.state, {
                value: value
            })
        );
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    processWaterColorChange = (val) => {
        var value: IValue = {
            GIS_service: _.clone(this.state.value.GIS_service),
            water_color: val,
            landscape_color: _.clone(this.state.value.landscape_color)
        };
        this.setState(
            _.extend(this.state, {
                value: value
            })
        );
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    processLandscapeColorChange = (val) => {
        var value = {
            GIS_service: _.clone(this.state.value.GIS_service),
            water_color: _.clone(this.state.value.water_color),
            landscape_color: val
        };
        this.setState(
            _.extend(this.state, {
                value: value
            })
        );
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    render() {
        var types = {
            values: ['OpenStreetMap', 'GoogleMap'],
            display: ['Open Street Map', 'Google Map']
        };
        var tzValue = this.state.value.GIS_service;
        var className = 'invisible';
        if (tzValue === 'GoogleMap') {
            className = 'visible margin';
        }

        return (
            <div className="pdc-widget-gis-config">
                <div className="margin">
                    <b>Select GIS service</b>
                    <SelectField value={tzValue} options={types} onChange={this.handleGISserviceChange} />
                </div>
                <div className={className}>
                    <b>Google Water Color</b>
                    <ColorBoxField
                        value={this.state.value.water_color}
                        returnHexadecimal={true}
                        hideTransparency={false}
                        showText={true}
                        onChange={this.processWaterColorChange}
                        glob={this.props.glob}
                    />
                </div>
                <div className={className}>
                    <b>Google landscape Color</b>
                    <ColorBoxField
                        value={this.state.value.landscape_color}
                        returnHexadecimal={true}
                        hideTransparency={false}
                        showText={true}
                        onChange={this.processLandscapeColorChange}
                        glob={this.props.glob}
                    />
                </div>
            </div>
        );
    }
}
